import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

const FALLBACK = '917898586002';
let cached = null;

export const useSupportWhatsApp = () => {
    const [wa, setWa] = useState(cached || '');
    useEffect(() => {
        if (cached) return;
        api.get('/recharge/support-contact')
            .then(r => { cached = r.data.whatsapp || FALLBACK; setWa(cached); })
            .catch(() => setWa(FALLBACK));
    }, []);
    return wa;
};

export const fmtPhone = (d) => (d && d.length === 12 && d.startsWith('91') ? `+91 ${d.slice(2, 7)} ${d.slice(7)}` : (d ? `+${d}` : '…'));

export const waLink = (wa, msg) => (wa ? `https://wa.me/${wa}?text=${encodeURIComponent(msg)}` : '#');
